/**
 * Generic Modal
 **/

var Modal = (function () {
    // Const & Refs
    var meta = {
        class: {
            outer: "g-modal",
            inner: "g-modal--inner",
            hidden: "hidden",
            actions: "g-modal--actions",
            title: "g-modal--title",
            content: "g-modal--content",
            titleIcon: "icon-pencil"
        },
        wrapper: null,
        content: null,
        _proto: null
    };

    // Set Refs
    function _init(payload) {
        meta._proto = meta;
        meta.wrapper = document.getElementById(meta.class.outer);
        meta.content = document.getElementById(meta.class.inner);
        return payload;
    };

    // Map objects to elements
    function _parse(payload){
        if (!payload) return false;

        if (payload.title) {
            var title = _build("div", "", meta.content, meta.class.title);
            var icon = _build("i", "", title, !!payload.icon ? payload.icon : meta.class.titleIcon);
            var text = _build("h3", payload.title, title);
        }

        if (payload.content) {
            _build("div", payload.content, meta.content, meta.class.content);
        }

        if (payload.callback) meta.callback = payload.callback;

        if (payload.actions) {
            var actions = _build("div", "", meta.content, meta.class.actions);

            for (var a = 0; a < payload.actions.length; a++) {
                var action = _build("button", "");
                if (payload.actions[a].icon) {
                    _build("i", "", action, payload.actions[a].icon);
                }
                action.innerHTML += payload.actions[a].title;

                if (payload.actions[a].onClick) {
                    action.onclick = payload.actions[a].onClick;
                }
                action.addEventListener("click", hide);
                actions.appendChild(action);
            }
        }
        return meta;
    };

    // Simple el builder
    function _build(tag, content, target, _class) {
        var el = document.createElement(tag);
        if (content) el.innerHTML = content;

        if (_class) el.classList.add(_class);

        if (target) target.appendChild(el);
        return el;
    };

    function _positionModal() {
        var $modalWrapper = $(meta.content);

        var newOffsetTop = window.parentScrollOffset;

        var windowHeight = $(window).height();
        var modalHeight = $modalWrapper.height();
        var maxPos = windowHeight - modalHeight;
        var modalOffsetBottom = modalHeight + newOffsetTop;
        if (modalOffsetBottom >= maxPos) {
            var diff = modalOffsetBottom - maxPos;
            newOffsetTop = window.parentScrollOffset - diff;
        }

        $modalWrapper.attr('style', 'transform: translateY(' + newOffsetTop + 'px);');
    }

    // Display by removing class
    function _display(canShow) {
        if (!canShow) return false;
        meta.wrapper.classList.remove(meta.class.hidden);
        _positionModal();
        return meta;
    };

    // Reset content
    function _cleanUp() {
        var _meta = Object.assign({}, meta);
        meta.content.innerHTML = "";
        meta = meta._proto;
        return _meta;
    }

    // Hide by applying class
    var hide = function () {
        if (meta.callback) meta.callback();
        return _cleanUp(meta.wrapper.classList.add(meta.class.hidden));
    }

    // Yeah, show
    var show = function (payload) {
        return _display(_parse(_init(payload)));
    };

    var alert = function (title, content, btnText, btnIcon) {
        return show({
            title: title,
            content: content,
            actions: [{
                title: btnText || $t("OK"),
                icon: btnIcon || "icon-check",
                onClick: hide
            }]
        });
    };

    // Public methods
    return {
        show: show,
        hide: hide,
        alert: alert
    }
}());
